import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import { history } from '../../../store';

import {displayPhone, displayDateFromTimestamp, getDiamondImage, getDiamondImagePlaceholder, formatDiamondTitle, formatMeasurements, formatLocation, formatCut, formatCarat, formatCost, formatColor, formatPrice, formatClarity, getUrlId} from '../../../utils/formatting';

import RhinoLoading from '../common/RhinoLoading';

import * as leadsActionCreators from '../../../actions/leads';
let allActionCreators = Object.assign({}, leadsActionCreators);

class SocialCard extends React.Component {


	constructor(props) {
		super(props);

    this.cardId = parseInt(getUrlId());

    this.state = {
      cardId: this.cardId,
      card: null,
      diamonds: [],
    }

    if(this.state.card === null) {

      this.props.fetchSocialCard(this.cardId)
      .then((respData) => {
        this.setState({ 
          card: respData.card,
          diamonds: respData.card.diamonds,
        });
      })
      // .catch((errorResp) => {
      //   console.error(errorResp);
      // });
    }
	}

  userNav(page) {
    history.push('/' + page);
  }

  getFullAddress() {
    if(!this.state.card) {
      return '';
    }
    return this.state.card.location.address_street + ' ' + this.state.card.location.address_city + ' ' + this.state.card.location.address_state + ' ' + this.state.card.location.address_zip;
  }

  getAddressLine1() {
    if(!this.state.card) {
      return '';
    }
    return this.state.card.location.address_street;
  }

  getAddressLine2() {
    if(!this.state.card) {
      return '';
    }
    return this.state.card.location.address_city + ' ' + this.state.card.location.address_state + ' ' + this.state.card.location.address_zip;
  }

  getGoogleUrl() {
    if(!this.state.card) {
      return '#';
    }
    // https://www.google.com/maps/search/15+address+way,+plano,+tx
    let addressString = this.state.card.location.address_street + ', ' + this.state.card.location.address_city + ', ' + this.state.card.location.address_state + ' ' + this.state.card.location.address_zip;
    return 'https://www.google.com/maps/search/' + encodeURIComponent(this.getFullAddress());
  }

	render() {
		return <div className='SocialCard'>
      {this.state.card === null ?
        <div className='leadLoading'>
          <RhinoLoading message='Loading information' />
        </div> :
        <div>
          <div className='shareWrapper'>
            <div className='shareInternalWrapper'>
              <div className='shareTitle'>The {this.state.card.first_name} Collection</div>
              <div className='shareHr'>
                <img src='/img/icons/lines/iconline_thin.svg' />
              </div>
              <div className='shareDiamonds'>
                {this.state.diamonds.map((diamond, i) => {
                  return <div className={'diamondElement'} key={i}>
                    <div className='imageWrapper'>
                      <img src={getDiamondImagePlaceholder(diamond)} />
                    </div>
                    <div className='titleWrapper'>{formatDiamondTitle(diamond)}</div>
                    <div className='infoWrapper'>
                      <div className='infoElement'>
                        <div className='infoLabel'>Cut:</div>
                        <div className='infoValue'>{formatCut(diamond)}</div>
                      </div>
                      <div className='infoElement'>
                        <div className='infoLabel'>Color:</div>
                        <div className='infoValue'>{formatColor(diamond)}</div>
                      </div>
                      <div className='infoElement'>
                        <div className='infoLabel'>Carat:</div>
                        <div className='infoValue'>{formatCarat(diamond)}</div>
                      </div>
                      <div className='infoElement'>
                        <div className='infoLabel'>Clarity:</div>
                        <div className='infoValue'>{formatClarity(diamond)}</div>
                      </div>
                    </div>
                  </div>;
                })}
              </div>
              <div className='shareAssociate'>
                <div className='blockTitle'>Your Personal Jeweler</div>
                <div className='associateName'>{this.state.card.associate.first_name + ' ' + this.state.card.associate.last_name}</div>
                <div className='associateContactWrapper'>
                  <a href={'mailto:' + this.state.card.associate.email} className={'associateContactButton actionButton'}>Contact</a>
                </div>
              </div>
              <div className='shareLocation'>
                <div className='blockTitle'>Your Diamonds Direct Store</div>
                <div className='locationName'>{this.state.card.location.full_name}</div>
                <div className='locationAddress'>{this.getFullAddress()}</div>
                <div className='locationMobileAddress'>{this.getAddressLine1()}</div>
                <div className='locationMobileAddress'>{this.getAddressLine2()}</div>
                <div className='locationDirectionsWrapper'>
                  <a href={this.getGoogleUrl()} target='_blank' className={'locationDirectionsButton actionButton'}>Directions</a>
                </div>
              </div>
              <div className='logoWrapper'>
                <img src='/img/login/logotag.svg' />
              </div>
            </div>
          </div>
        </div>
      }
    </div>;
	}
}
export default SocialCard;

function mapStateToProps(state) {
  return {
    leads: state.leads,
  };
}

export const SocialCardContainer = connect(
  mapStateToProps,
  allActionCreators
)(SocialCard);